import { useMutation, useQuery } from '@tanstack/react-query';

import * as tboAuditApi from './tbo-audit.api';

import type { TboAuditListQuery } from '@utazzo/shared';

/** Admin-only TBO API audit list. Query key carries the full filter set. */
export const useTboAuditList = (query: TboAuditListQuery) =>
  useQuery({
    queryKey: ['tbo-audit', 'list', query],
    queryFn: () => tboAuditApi.listTboAudit(query),
    staleTime: 15_000,
  });

/**
 * Lazily fetch the presigned body URL for a single audit row. A mutation (not a
 * query) so the presigned URL is only minted when the operator clicks "View
 * full payload" - it is short-lived and shouldn't be prefetched or cached.
 */
export const useTboAuditBodyUrl = () =>
  useMutation({
    mutationFn: (id: string) => tboAuditApi.getTboAuditBodyUrl(id),
  });
